/* eslint-disable no-undef */
import React, {Component} from "react";
import {Checkbox, FormControl, FormControlLabel, FormGroup} from '@material-ui/core';
import 'react-tabs/style/react-tabs.css';
import Api from "../../../../../Services/Api";

class TabCompanyAccess extends Component {
    constructor(props) {
        super(props);
        this.state = {
            data: props.data ? props.data : {
                roleId: ""
            },
            dataRequest: [],
            companyAccessData: [],
        }
    }

    componentDidMount() {
        this.getRoleCompany()
    }

    getRoleCompany() {
        let payload = {
            roleId: this.state.data.roleId,
        }
        if (this.props.data.accessType === 'Allowed') {
            Api.create('MASTERDATA_EKSAD').postGetRoleCompanyAllowed(payload).then(
                (res) => {
                    if (res.ok && res.data.status === 'S') {
                        let array = []
                        let arrayDataRequest = []
                        res.data.data && res.data.data.map((item) => {
                            array.push(item)
                            if (item.accessData) {
                                arrayDataRequest.push({
                                    roleId: item.roleId,
                                    companyId: this.state.data.companyId,
                                    accessCompanyId: item.companyId,
                                    status: "Active",
                                })
                            }
                        })
                        this.setState({
                            companyAccessData: array,
                            dataRequest: arrayDataRequest
                        })
                    }
                })
        } else {
            Api.create('MASTERDATA_EKSAD').postGetRoleCompanyBanned(payload).then(
                (res) => {
                    if (res.ok && res.data.status === 'S') {
                        let array = []
                        let arrayDataRequest = []
                        res.data.data && res.data.data.map((item) => {
                            array.push(item)
                            if (item.accessData) {
                                arrayDataRequest.push({
                                    roleId: item.roleId,
                                    companyId: this.state.data.companyId,
                                    accessCompanyId: item.companyId,
                                    status: "Active",
                                })
                            }
                        })
                        this.setState({
                            companyAccessData: array,
                            dataRequest: arrayDataRequest
                        })
                    }
                })
        }
    }

    onCheckAccess(e) {
        let dataArray = [...this.state.companyAccessData];
        let objIndex = dataArray.findIndex((obj => obj.companyName === e.companyName));
        if (e.accessData === false) {
            dataArray[objIndex].accessData = true
            this.setState({
                companyAccessData: dataArray,
            })
            this.state.dataRequest.push({
                roleId: dataArray[objIndex].roleId,
                companyId: this.state.data.companyId,
                accessCompanyId: dataArray[objIndex].companyId,
                status: "Active",
            })
        } else {
            dataArray[objIndex].accessData = false
            this.setState({
                companyAccessData: dataArray,
            })
            let index = this.state.dataRequest.findIndex((obj => obj.accessCompanyId === dataArray[objIndex].companyId));
            this.state.dataRequest.splice(index, 1);
        }
        this.props.requestData(this.state.dataRequest);
    }

    render() {
        return (
            <div style={{width: '50%', height: '80%'}}>
                <div>
                    {this.state.companyAccessData.map((item, i) => {
                        return (
                            <div key={i} className="grid grid-1x grid-mobile-none gap-15px">
                                <div className="column-1">
                                    <FormControl>
                                        <FormGroup>
                                            <div style={{marginTop: 5}}>
                                                <FormControlLabel
                                                    control={
                                                        <Checkbox
                                                            style={{color: 'grey'}}
                                                            checked={item.accessData}
                                                            onChange={() => this.onCheckAccess(item)}
                                                            disabled={this.props.type === "view"}
                                                        />}
                                                    label={<span
                                                        style={{fontSize: '15px'}}>{item.companyName}</span>}
                                                />
                                            </div>
                                        </FormGroup>
                                    </FormControl>
                                </div>
                            </div>
                        )
                    })}
                </div>
            </div>
        )
    }
}

export default TabCompanyAccess;